import { Component,
         Output,
         EventEmitter }             from '@angular/core';
import { TableColumn,
         TableColumnType }          from './../common/table-column';
import { ISortableFilter }          from './../common/sortable-filter';
import { BusRouteSortableFilter }   from './bus-route-sortable-filter';
import { SavingDialogComponent }    from './../common/saving-dialog.component';
import { BusRouteModel }            from './bus-route.model';
import { MatDialog }                 from '@angular/material';
import { Globals }                  from './../common/globals';
import { BusRouteDialogComponent }  from '../bus-route-dialog/bus-route-dialog.component';
import { BusRouteService }          from '../shared/bus-route.service';


@Component({
  selector: 'sa-bus-route-list',
  template: require('./bus-route-list.component.html'),
  styles: [require('./bus-route-list.component.scss')]
})
export class BusRouteListComponent {

  @Output() columns: Array<TableColumn>;
  @Output() filter = new BusRouteSortableFilter('routeNumber');
  @Output() performSearch = new EventEmitter();
  @Output() productUpdated = new EventEmitter();

  public getDataCallback: Function;

  private apiService: BusRouteService;

  constructor(
    apiService: BusRouteService,
    private dialog: MatDialog,
    public globals: Globals
  ) {
    this.apiService = apiService;
    this.getDataCallback = this.getData.bind(this);
    this.filter.activeOnly = true;

    this.columns = [
        new TableColumn(TableColumnType.Text, 'routeNumber', 'Číslo trasy', 100),
        new TableColumn(TableColumnType.Text, 'routeShortName', 'Jméno trasy - krátké', 60),
        new TableColumn(TableColumnType.Text, 'routeName', 'Jméno trasy', 150),
        new TableColumn(TableColumnType.Bool, 'active', 'Aktivní', 80)
    ];
  }

  private getData(filter: ISortableFilter) {
    return this.apiService.getItems(filter);
  }

  public addNew() {
    let dialogRef = this.dialog.open(BusRouteDialogComponent);
    dialogRef.componentInstance.model = new BusRouteModel();
    dialogRef.componentInstance.newItem = true;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.insertItem(dialogRef.componentInstance.model)
        .subscribe(res => {
            cloakRef.close();
            this.search();
          });
      }
    });
  }

  public search() {
    this.performSearch.emit(this.filter);
  }

  public editItem(model: BusRouteModel) {
    let dialogRef = this.dialog.open(BusRouteDialogComponent);
    dialogRef.componentInstance.model = model;
    dialogRef.componentInstance.newItem = false;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.updateItem(dialogRef.componentInstance.model.busRouteID, dialogRef.componentInstance.model)
          .subscribe(res => {
            cloakRef.close();
            console.log('Bus updated');
            this.search();
          });
      } else if (result === 'delete') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.deleteItem(dialogRef.componentInstance.model.busRouteID)
          .subscribe(
            data => {
              cloakRef.close();
              console.log('Bus deleted');
              this.search();
          },
            err => {
              cloakRef.close();
              window.alert('Vybraná položka nemohla být odstraněna.');
            }
          );
      } else {
        this.search();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/bus-route-list/bus-route-list.component.ts